import Experience from "../Experience.js"

export default class LoadingScreen {
    constructor() {
        this.experience = new Experience()
        this.resources = this.experience.resources

        // DOM elements
        this.overlay = document.getElementById("loader-overlay")
        this.percentage = document.getElementById("loader-percentage")
        this.statusText = document.getElementById("loader-status")

        this.parentReady = false
        this.iframeReady = false

        // Listen to progress and ready events
        this.resources.on("progress", (loaded, toLoad, name) => {
            this.update(loaded, toLoad, name)
        })

        this.resources.on("ready", () => {
            this.parentReady = true
            this.checkReady()
        })

        window.onIframeReady = () => {
            this.iframeReady = true
            this.checkReady()
        }

        // Prevent click-through / interaction with the scene behind during loading
        if (this.overlay) {
            const blockEvent = (e) => {
                e.stopPropagation()
            }
            const events = ["pointerdown", "pointerup", "mousedown", "mouseup", "click", "touchstart", "touchend"]
            events.forEach(eventName => {
                this.overlay.addEventListener(eventName, blockEvent)
            })
        }
    }

    update(loaded, toLoad, name) {
        const percent = Math.round((loaded / toLoad) * 100)

        if (this.progressBar) {
            this.progressBar.style.transform = `scaleX(${percent / 100})`
        }

        if (this.percentage) {
            this.percentage.innerText = `${percent}%`
        }

        if (this.statusText) {
            this.statusText.innerText = `Loading: ${name}...`
        }
    }

    checkReady() {
        if (this.parentReady && this.iframeReady) {
            this.hide()
        }
    }

    hide() {
        if (this.overlay) {
            this.overlay.classList.add("loaded")
            setTimeout(() => {
                this.overlay.remove()
            }, 1000)
        }
    }
}
